/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Youtube_Export_DescriptionInputs */

const cs_youtube_export_description = /** @type {(inputs: Youtube_Export_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Popis na YouTube`)
};

const en_youtube_export_description = /** @type {(inputs: Youtube_Export_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`YouTube description`)
};

/**
* | output |
* | --- |
* | "YouTube description" |
*
* @param {Youtube_Export_DescriptionInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const youtube_export_description = /** @type {((inputs?: Youtube_Export_DescriptionInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Youtube_Export_DescriptionInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_youtube_export_description(inputs)
	return cs_youtube_export_description(inputs)
});